import { useEffect, useState } from 'react';
import { xorBy } from 'lodash';

import { CheckboxItem } from '../core/checkbox-group';

import { Modal } from 'components/modal/modal';
import { Button } from 'components/button';
import { CheckboxGroup } from 'components/checkbox-group/checkbox-group';

interface ICheckboxesModalProps {
	modal: {
		modalTitle: string;
		modalType: string;
		modalOpen: boolean;
	};
	filters: CheckboxItem[];
	options: any;
	setModalOpen: () => void;
	setModalSelected: (items: CheckboxItem[]) => void;
}

const CheckboxesModal = (props: ICheckboxesModalProps): React.JSX.Element => {
	const { modalTitle, modalOpen } = props.modal;

	const [tempItems, setTempItems] = useState<CheckboxItem[]>(props.filters);
	const [items, setItems] = useState<CheckboxItem[]>(props.options);

	useEffect(() => {
		setTempItems(props.filters);
		setItems(props.options);
	}, [modalOpen, props.options]);

	const handleTempChange = (e: CheckboxItem[]): void => {
		const newItems = xorBy(tempItems, e, (item: any) => item.id);
		setTempItems(newItems);
	};
	const handleSubmit = (): void => {
		props.setModalOpen();
		props.setModalSelected(tempItems);
	};

	return (
		<Modal
			isOpen={modalOpen}
			onClose={props.setModalOpen}
			title="Filteren"
			maxWidth={800}
			footerButtons={{
				submitButton: <Button title="Toon resultaten" variant="primary" onClick={handleSubmit} />
			}}
		>
			<div>
				<h3 id={modalTitle}>{modalTitle}</h3>
				<CheckboxGroup
					groupName="modalItems"
					items={
						items || [
							{
								id: '',
								label: ''
							}
						]
					}
					onChange={handleTempChange}
					selectedItems={tempItems}
					singleColumn
					sortByName
				/>
			</div>
		</Modal>
	);
};

export { CheckboxesModal };
